/**
 * Builds a Confluence onboarding URL from hostname and site trait value.
 * The trait value format is expected to be "<SPACE_KEY>-<PAGE_ID>".
 * @param hostname - The hostname from TCS (e.g., "example.atlassian.net")
 * @param traitValue - The site trait value containing space key and page ID in format "<SPACE_KEY>-<PAGE_ID>"
 * @returns The constructed Confluence URL, or undefined if inputs are invalid
 */
export const getConfluenceOnboardingUrl = (
	hostname: string | undefined,
	traitValue: string | undefined,
): string | undefined => {
	if (!hostname || !traitValue) {
		return undefined;
	}

	const parts = traitValue.split('-');
	if (parts.length !== 2) {
		return undefined;
	}

	const [spaceKey, pageId] = parts;

	if (!spaceKey || !pageId) {
		return undefined;
	}

	return `${hostname}/wiki/spaces/~${spaceKey}/pages/${pageId}`;
};
